import { useOktaAuth } from "@okta/okta-react";
import axios from "axios";

import { useQuery } from "@tanstack/react-query";

export function useFetchLayoutConstants(isAuthenticated) {
  const { oktaAuth } = useOktaAuth();

  const dataKey = "useFetchLayoutConstantsResultKey";

  async function GetConstants() {
    const accessToken = oktaAuth.getAccessToken();

    //alert("GetConstants");

    var result = await axios
      .get("api/Constants/GetConstants", {
        headers: { Authorization: `Bearer ${accessToken}` },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw new Error(error);
      });

    return result;
  }

  function IsEnabled() {
    if (!isAuthenticated) return false;

    return true;
  }

  return useQuery({
    queryKey: [dataKey],
    queryFn: async () => await GetConstants(),
    enabled: IsEnabled,
  });
}
